module.exports = __webpack_public_path__ + "img/product_129.d906e65.svg";